import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    ProsecutionExampleService,
    ProsecutionExampleServiceImpl,
} from './services/prosecution-example-service';

export const prosecutionContainer = new ContainerModule((bind) => {
    bind(ProsecutionExampleService).to(ProsecutionExampleServiceImpl);
});
